<template>
  <!-- Note this is now Legacy, as it is Connect-E now -->
  <div>
    <!-- Modal loadingModal -->
    <div class="modal fade " ref="loadingModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="loadingLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title heading text-black" id="loadingLabel">Connecting to Payment Sense</h4>
                <br>
                <p id="lockingError" class="text-black">
                  If you are using Internet Explorer (or the spinner keeps on spinning), this currently does not work (get Bill Gates in here!).
                  Please <a :href="$deploymentIn(['cryptology', 'breakescape', 'trapped']) ? route($deploymentCurrent + '.location.contact', location.slug) : route($deploymentCurrent + '.contact-us')">contact us.</a>
                </p>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col" id="ajaxImg">
                <img class="mx-auto d-block" src="/img/ajax_lg.gif" alt="Awaiting server to retrieve the information"> <!-- TODO: see if we can use the Vue Loading spinner -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- .modal loadingModal -->

    <form :id="$id('paymentsenseForm')" :action="paymentRequest.formAction" method="post" ref="paymentsenseForm">
      <input type="hidden" name="HashDigest" :value="paymentRequest.HashDigest"/>
      <input type="hidden" name="MerchantID" :value="paymentRequest.MerchantID"/>
      <input type="hidden" name="Amount" :value="paymentRequest.Amount"/>
      <input type="hidden" name="CurrencyCode" :value="paymentRequest.CurrencyCode"/>
      <input type="hidden" name="OrderID" :value="paymentRequest.OrderID"/>
      <input type="hidden" name="TransactionType" :value="paymentRequest.TransactionType"/>
      <input type="hidden" name="TransactionDateTime" :value="paymentRequest.TransactionDateTime"/>
      <input type="hidden" name="CallbackURL" :value="paymentRequest.CallbackURL"/>
      <input type="hidden" name="OrderDescription" :value="paymentRequest.OrderDescription"/>
      <input type="hidden" name="CustomerName" :value="paymentRequest.CustomerName"/>
      <input type="hidden" name="EmailAddress" :value="paymentRequest.EmailAddress"/>
      <input type="hidden" name="EmailAddressEditable" :value="paymentRequest.EmailAddressEditable"/>
      <input type="hidden" name="PhoneNumberEditable" :value="paymentRequest.PhoneNumberEditable"/>
      <input type="hidden" name="CV2Mandatory" :value="paymentRequest.CV2Mandatory"/>
      <input type="hidden" name="Address1Mandatory" :value="paymentRequest.Address1Mandatory"/>
      <input type="hidden" name="CityMandatory" :value="paymentRequest.CityMandatory"/>
      <input type="hidden" name="PostCodeMandatory" :value="paymentRequest.PostCodeMandatory"/>
      <input type="hidden" name="StateMandatory" :value="paymentRequest.StateMandatory"/>
      <input type="hidden" name="CountryMandatory" :value="paymentRequest.CountryMandatory"/>
      <input type="hidden" name="ResultDeliveryMethod" :value="paymentRequest.ResultDeliveryMethod"/>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },

    paymentProviderPublicOptions: {
      type: [Array, Object],
      default: null,
    },
  },

  data() {
    return {
      // paymentRequest used as the v-model for the inputs above
      // this is the template payment request we need to fill in, this must match GeneratePaymentRequest.php and all the fields must be in the <form> above
      paymentRequest: {
        formAction: null,
        HashDigest: null,
        MerchantID: null,
        Amount: null,
        CurrencyCode: null,
        OrderID: null,
        TransactionType: null,
        TransactionDateTime: null,
        CallbackURL: null,
        OrderDescription: null,
        CustomerName: null,
        EmailAddress: null,
        EmailAddressEditable: null,
        PhoneNumberEditable: null,
        CV2Mandatory: null,
        Address1Mandatory: null,
        CityMandatory: null,
        PostCodeMandatory: null,
        StateMandatory: null,
        CountryMandatory: null,
        ResultDeliveryMethod: null,
      },
    };
  },

  methods: {
    /* ===============
     * public methods
     */

    takeSalePayment(sale, allowDepositFlag = false) {
      let request = {
        saleId: sale.id,
        deposit: allowDepositFlag,
      };

      this.showLoadingModal();
      this.fetchPaymentRequest(request);
    },

    takeBookingPayment(booking) {
      let request = {
        bookingId: booking.id,
      };

      this.showLoadingModal();
      this.fetchPaymentRequest(request);
    },

    takeVoucherPayment(voucher) {
      let request = {
        voucherId: voucher.id,
      };

      this.showLoadingModal();
      this.fetchPaymentRequest(request);
    },

    takeVirtualGamePayment(virtualGame, sale, from) {
      let request = {
        virtualGameId: virtualGame.id,
        saleId: sale.id,
        from: from,
      };

      this.showLoadingModal();
      this.fetchPaymentRequest(request);
    },

    /*
     * END public methods
     * =============== */

    /* ===============
     * loadingModal methods
     */

    showLoadingModal() {
      // Do any prep before showing the modal

      $(this.$refs.loadingModal).modal('handleUpdate');
      $(this.$refs.loadingModal).modal('show');
    },

    hideLoadingModal() {
      $(this.$refs.loadingModal).modal('hide');
    },

    loadingModalHidden() {
      // console.log('loadingModalHidden');
    },

    /*
     * END loadingModal methods
     * =============== */

    fetchPaymentRequest(request) {
      // console.log('fetchPaymentRequest', request);

      axios.post(this.route('api.paymentsense.payment-request'), request)
        .then(response => {
           if (response.status == 200) {
            let newPaymentRequest = response.data;

            // console.log('axios response:', newPaymentRequest);
            this.paymentRequest = newPaymentRequest; // now with all the booking details

            this.$nextTick(() => {
              // console.log('paymentsenseForm:submit');
              this.$refs.paymentsenseForm.submit();
            })
          } else {
            flash('Error fetching PaymentRequest', 'error');
            console.log('fetchPaymentRequest', response.data);
            console.log('fetchPaymentRequest', response.status);
            console.log('fetchPaymentRequest', response.statusText);
          }

        })
        .catch(error => {
          flash('Error setting up Paymentsense payment', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('fetchPaymentRequest:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('fetchPaymentRequest:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('fetchPaymentRequest:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('fetchPaymentRequest:401', error.response.data);
              window.location.reload();
            } else {
              console.log('fetchPaymentRequest: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('fetchPaymentRequest: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('fetchPaymentRequest: Error', error.message);
          }
        });
    },
  },

  mounted() {
    $(this.$refs.loadingModal).on('hidden.bs.modal', this.loadingModalHidden);
  },
}
</script>
